export default "__VITE_ASSET__f34180f2__"